import { jsonPost } from '../api'

export const createVehicle = (token, tag, make, model, color) =>
    jsonPost(`${GRS_ACCOUNTS_SERVICE}/SaveVehicle`, {
        LAZVehicleDetail: [
            {
                Id: 0,
                State: '',
                Tag: tag,
                Name: '',
                Color: color,
                Make: make,
                Model: model,
                Active: true,
            },
        ],
        Token: token,
    }).catch(error => {
        throw new Error(error.message)
    })

export const removeVehicle = vehicle =>
    jsonPost(`${GRS_ACCOUNTS_SERVICE}/SaveVehicle`, {
        LAZVehicleDetail: [
            {
                Id: vehicle.id,
                State: '',
                Tag: '',
                Name: '',
                Color: '',
                Make: '',
                Model: '',
                Active: false,
            },
        ],
    }).catch(error => {
        throw new Error(error.message)
    })
